"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
rxjs_1.Observable.empty = rxjs_1.empty;
//# sourceMappingURL=empty.js.map